import { render, staticRenderFns } from "./StampTable.vue?vue&type=template&id=e9f52746&scoped=true&"
import script from "./StampTable.vue?vue&type=script&lang=js&"
export * from "./StampTable.vue?vue&type=script&lang=js&"
import style0 from "./StampTable.vue?vue&type=style&index=0&id=e9f52746&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9f52746",
  null
  
)

export default component.exports